export default "__VITE_ASSET__DLGIwQNn__"